import { type StateCreator } from 'zustand';
import { captureLogger } from '../configure/logger-facade';
import { type CaptureLogFn } from '../ports/logger';
import { type AudioGraphStore } from './types';

const logger = captureLogger.child({ module: 'audio-graph' });

export interface LoggingSlice {
  logError: CaptureLogFn;
  logWarn: CaptureLogFn;
  logInfo: CaptureLogFn;
  logDebug: CaptureLogFn;
}

export const createLoggingSlice: StateCreator<
  AudioGraphStore,
  [],
  [],
  LoggingSlice
> = () => ({
  logError: logger.error.bind(logger),
  logWarn: logger.warn.bind(logger),
  logInfo: logger.info.bind(logger),
  logDebug: logger.debug.bind(logger),
});
